import { Legend, Radar, RadarChart, Tooltip, XAxis, YAxis } from 'recharts';

import { ReportWidgetChartTooltip } from './ReportWidgetTooltipContent';

import type {
    ReportWidgetChartPoint,
    ReportWidgetItem,
} from '../../model/types';

interface ReportWidgetRadarChartProps {
    data: ReportWidgetChartPoint[];
    showLegend: boolean;
    tooltipFormatter: (value: number) => string;
    items: ReportWidgetItem[];
    total: number;
    width?: number;
    height?: number;
    disableAnimation?: boolean;
}

export const ReportWidgetRadarChart = ({
    data,
    showLegend,
    tooltipFormatter,
    items,
    total,
    width,
    height,
    disableAnimation = false,
}: ReportWidgetRadarChartProps) => {
    const sizeProps =
        width != null || height != null ? { width, height } : undefined;

    return (
        <RadarChart cx="50%" cy="50%" data={data} {...sizeProps}>
            <Radar
                dataKey="value"
                stroke="#5ca1ff"
                fill="#5ca1ff"
                fillOpacity={0.4}
                isAnimationActive={!disableAnimation}
            />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip
                content={
                    <ReportWidgetChartTooltip
                        tooltipFormatter={tooltipFormatter}
                        total={total}
                        items={items}
                    />
                }
            />
            {showLegend && <Legend />}
        </RadarChart>
    );
};
